import { useState } from 'react';
import { useSnackbar } from 'notistack';
import { getResponseMessage } from '../../../../../utils/utils';
import { useFormatMessage } from '../../../../../hooks';
import { getLocationGeocode } from '../../../../../crud/location.crud';

export type Location = {
  fullAddress?: string;
  address: string;
  description?: string;
  lat: number;
  lng: number;
  city?: string;
  createdAt?: Date;
  province?: string;
};

export const useGetLocation = (setFieldValue: any, setStart: any, setEnd: any) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loadingLocation, setLoading] = useState(false);
  const fm = useFormatMessage();

  const fetchGeocode = async ({
    value,
    startLocation,
    endLocation,
    address,
    onlyCity,
  }: {
    value: string;
    startLocation?: boolean;
    endLocation?: boolean;
    address: string;
    onlyCity?: boolean;
  }) => {
    setLoading(true);
    getLocationGeocode(`${onlyCity ? 'Ингушетия, ' : ''}${value}`)
      .then(res => {
        const result = googleDataToEntities(
          res.data.response.GeoObjectCollection.featureMember
        );
        if (!result) return;
        const updatedAddress = {
          ...result,
          address,
          fullAddress: address,
        };
        if (startLocation) {
          setFieldValue('startLocation', updatedAddress);
          setStart(updatedAddress);
        }
        if (endLocation) {
          setFieldValue('endLocation', updatedAddress);
          setEnd(updatedAddress);
        }
      })
      .catch(e => {
        enqueueSnackbar(`${fm('ERROR')}: ${getResponseMessage(e)}`);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return {
    fetchGeocode,
    loadingLocation,
  };
};

export function googleDataToEntities(data: any) {
  try {
    const res = data
      .filter(
        (i: any) =>
          i.GeoObject.metaDataProperty?.GeocoderMetaData?.Address?.country_code === 'RU'
      )
      .map((i: any) => ({
        fullAddress: i.GeoObject.metaDataProperty.GeocoderMetaData.Address.formatted,
        address: i.GeoObject.name,
        description: i.GeoObject.description,
        lat: Number(i.GeoObject.Point.pos.split(' ')[1]),
        lng: Number(i.GeoObject.Point.pos.split(' ')[0]),
        province:
          i.GeoObject.metaDataProperty?.GeocoderMetaData?.Address?.Components?.find(
            (i: any) => i?.kind === 'locality'
          )?.name ||
          i.GeoObject.metaDataProperty?.GeocoderMetaData?.Address?.Components?.find(
            (i: any) => i?.kind === 'province'
          )?.name ||
          '',
        city:
          i.GeoObject.metaDataProperty?.GeocoderMetaData?.Address?.Components?.find(
            (i: any) => i?.kind === 'locality'
          )?.name || '',
      }));
    return res[0];
  } catch (e) {
    return null;
  }
}
